/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
//@ts-nocheck
import React from 'react';
import { OrgComplianceListContainer } from './container';
import { useNavigate } from 'react-router-dom';

export const OrgCompliancePage = ({ navigation }: { navigation: any }) => {
  let navigate = useNavigate();

  return (
    <OrgComplianceListContainer
      onViewClick={(item: any) => {
        console.log('onViewClick', item);
        navigate(`/compliance-detail`, { state: item });
      }}
    />
  );
};
